import { cn } from '@shared/components/ui/cn';

/** The bars' heights from the inline start: 4, 6, 8, 10 and 12 px. */
const HEIGHTS = ['h-1', 'h-1.5', 'h-2', 'h-2.5', 'h-3'] as const;

/**
 * The five-bar level glyph: `filled` bars lit from the inline start (barsOf), 1 px apart. On the
 * Thinking chip (`tone="chip"`) the lit bars are the muted grey and the rest stay drawn at full
 * height in a lighter one; on a model row (`tone="cap"`, the model's cap) the lit bars take that
 * lighter grey and the rest are faint dots (F1, S1, S2).
 */
export function LevelGlyph({ filled, tone }: { filled: number; tone: 'chip' | 'cap' }) {
  return (
    <span
      aria-hidden="true"
      data-bars={filled}
      className="flex size-4 shrink-0 items-end gap-px py-0.5"
    >
      {HEIGHTS.map((height, i) => {
        const lit = i < filled;
        return (
          <span
            key={height}
            className={cn(
              'w-0.5 shrink-0 rounded-[1px]',
              lit || tone === 'chip' ? height : 'h-0.5',
              lit
                ? tone === 'chip'
                  ? 'bg-muted-foreground'
                  : 'bg-muted-foreground/60'
                : tone === 'chip'
                  ? 'bg-muted-foreground/60'
                  : 'bg-muted-foreground/25',
            )}
          />
        );
      })}
    </span>
  );
}
